import {
    Divider,
    Flex,
    InfoIcon,
    Skeleton,
    Text,
    Tooltip,
} from "@fluentui/react-northstar";
import React from "react";
import styled from "styled-components";
import { CalendarClockRegular } from "@fluentui/react-icons";
import DialogRecoveryYearly from "../../Dialogs/DialogRecoveryYearly/DialogRecoveryYearly";
import { format_number } from "../../../constants/maths";

const CardAnnualRecovery = ({
    actualSolde,
    totalAcquired,
    compensated,
    hoursCountPerDay,
    actualSoldeInDays,
    totalAcquiredInDays,
    compensatedInDays,
    isLoading = false,
}) => {
    let f_actual_solde =
        actualSolde > 0
            ? "+ " + format_number(actualSolde)
            : format_number(actualSolde);

    return (
        <Card column>
            <Flex vAlign="center" gap="gap.smaller" space="between" fill>
                <Flex vAlign="center" gap="gap.smaller">
                    <Icon>
                        <CalendarClockRegular
                            fontSize={20}
                            color={"var(--color-primary)"}
                        />
                    </Icon>
                    <STextRecuperation content="Récupération annuelle" />
                </Flex>
                <Flex vAlign="center">
                    <DialogRecoveryYearly
                        actualSolde={actualSolde}
                        totalAcquired={totalAcquired}
                        compensated={compensated}
                        hoursCountPerDay={hoursCountPerDay}
                        actualSoldeInDays={actualSoldeInDays}
                        totalAcquiredInDays={totalAcquiredInDays}
                        compensatedInDays={compensatedInDays}
                    />
                </Flex>
            </Flex>
            <Flex vAlign="center" space="between" fill>
                <Flex>
                    {isLoading ? (
                        <Skeleton animation="pulse">
                            <Skeleton.Line width="90px" height="26px" />
                        </Skeleton>
                    ) : (
                        <HoursText>{f_actual_solde}</HoursText>
                    )}
                </Flex>
                <Flex>
                    <Divider vertical styles={{ height: "20px" }} />
                </Flex>
                <Flex vAlign="center" gap="gap.smaller">
                    {isLoading ? (
                        <Skeleton animation="pulse">
                            <Skeleton.Line width="120px" height="26px" />
                        </Skeleton>
                    ) : (
                        <STextDetail>soit {actualSoldeInDays}</STextDetail>
                    )}
                    <Tooltip
                        content={isLoading ? "" : `1 j = ${hoursCountPerDay} h`}
                        subtle={false}
                        trigger={<InfoIcon outline size="medium" />}
                        pointing
                        position="before"
                        align="center"
                    />
                </Flex>
            </Flex>
        </Card>
    );
};

export default CardAnnualRecovery;

const STextDetail = styled(Text)`
    color: var(--Light-theme-Rest-Foreground-Default-Foreground-2, #616161);

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
`;

const HoursText = styled(Text)`
    color: var(--Light-theme-Rest-Foreground-Brand-Foreground, #5b5fc7);
    font-family: "Baloo Bhaijaan 2";
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px; /* 100% */
    position: relative;

    ::after {
        content: "h";
        font-size: 12px;
        position: absolute;
        bottom: -10px;
    }
`;

const STextRecuperation = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-242424,
        #242424
    );

    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 142.857% */
`;

const Icon = styled(Flex)`
    border-radius: 32px;
    background: var(
        --Light-theme-Rest-Background-Default-Background-2,
        #f5f5f5
    );

    width: 36px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Card = styled(Flex)`
    width: 310px;
    padding: 16px;
    align-items: flex-end;
    gap: var(--spacing-m-16, 16px);

    border-radius: 16px;
    border: 2px solid var(--Light-theme-Rest-Border-Brand-Border-1, #9299f7);
    background: var(--Light-theme-Rest-Background-Default-Background, #fff);

    /* shadow-2 */
    box-shadow: 0px 0.15px 0.45px 0px rgba(0, 0, 0, 0.11),
        0px 0.8px 1.8px 0px rgba(0, 0, 0, 0.13);
`;
